import * as Yup from "yup";

export function getConfigBillSchema() {
  return Yup.object().shape({
  rfc: Yup.string()
    .required("Campo requerido")
    .matches(
      /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/,
      "Campo requerido"
    ),
  name: Yup.string().required("Campo requerido"),
  // description: Yup.string().required("Campo requerido"),
  fiscalRegimeId: Yup
    .mixed()
    .test(
      "is-selected",
      "El régimen fiscal es requerido",
      (value) => value !== null && typeof value === "object" && !!value.id
    )
    .required("El régimen fiscal es requerido"),

   // Contraseña solo si hay archivos cargados
  // csdPassword: Yup.string().when(["b64Cer", "b64Key"], {
  //   is: (cer, key) => !!cer || !!key,
  //   then: (schema) => schema.required("La contraseña es requerida"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  postalCode: Yup.string()
  .required("El código postal es requerido")
  .matches(/^\d{5}$/, "Debe tener exactamente 5 dígitos numéricos"),

  primaryColor: Yup.string().required("El color es obligatorio"),
  });
}